var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 5.3125C10.4688 5.11719 10.1953 5 9.96094 5C9.64844 5.03906 9.41406 5.11719 9.25781 5.3125L5.85938 9.0625C5.58594 9.33594 5.54688 9.72656 5.70312 10.0781C5.82031 10.4297 6.17188 10.625 6.52344 10.625H8.71094L8.75 14.0625C8.75 14.6094 9.14062 15 9.6875 15H10.3125C10.8203 15 11.2109 14.6094 11.2109 14.0625V10.625H13.3984C13.75 10.625 14.1016 10.4297 14.2578 10.0781C14.375 9.72656 14.3359 9.33594 14.0625 9.0625L10.625 5.3125ZM10 0C4.45312 0 0 4.49219 0 10C0 15.5469 4.45312 20 10 20C15.5078 20 20 15.5469 20 10C20 4.49219 15.5078 0 10 0ZM10 18.125C5.50781 18.125 1.875 14.4922 1.875 10C1.875 5.54688 5.50781 1.875 10 1.875C14.4531 1.875 18.125 5.54688 18.125 10C18.125 14.4922 14.4531 18.125 10 18.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.c5160786c21dc224dd0fb95a9e6a8939.svg";
export { ForwardRef as ReactComponent };